import { NgModule } from "@angular/core";
import {
    NgbdDatepickerRange,
    NgbdDatepickerOmbrFinoA
} from "./datepicker/datepicker-ita/datepicker-ita.component";
import { NgbdTimepickerBasic } from "./gest-ristorante/gest-ristorante.component";
import { SbDatepickerComponent } from "./datepicker/sb-datepicker/sb-datepicker.component";
import { SbDatepickerFormComponent } from "./datepicker/sb-datepicker/sb-datepicker-form.component";
import { SbFasciaOrariaComponent } from "./datepicker/sb-datepicker/sb-fascia-oraria.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from "@angular/common";

@NgModule({
    declarations: [
        NgbdDatepickerRange,
        NgbdDatepickerOmbrFinoA,
        NgbdTimepickerBasic,
        SbDatepickerComponent,
        SbDatepickerFormComponent,
        SbFasciaOrariaComponent,
    ],
    exports: [
        NgbdDatepickerRange,
        NgbdDatepickerOmbrFinoA,
        NgbdTimepickerBasic,
        SbDatepickerComponent,
        SbDatepickerFormComponent,
        SbFasciaOrariaComponent],

    imports: [
        ReactiveFormsModule,
        FormsModule,
        NgbModule,
        CommonModule],
})
export class DatePickerModule { }
